import { render, staticRenderFns } from "./EditPassenger.vue?vue&type=template&id=32748ed0&"
import script from "./EditPassenger.vue?vue&type=script&lang=js&"
export * from "./EditPassenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports